import { render, staticRenderFns } from "./JornadaDaCota.vue?vue&type=template&id=4842d3b8&scoped=true&"
import script from "./JornadaDaCota.vue?vue&type=script&lang=js&"
export * from "./JornadaDaCota.vue?vue&type=script&lang=js&"
import style0 from "./JornadaDaCota.vue?vue&type=style&index=0&id=4842d3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842d3b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCol,VContainer,VIcon,VRow,VSkeletonLoader})
